<template>
  <div>
    <div class="row payment_options d-flex align-items-center">
      <label
        v-if="hasDanishCPR"
        class="
          payment-option-label
          ml-sm-3 ml-4
          mr-5
          mt-4
          d-flex
          align-items-center
        "
        for="mobilepay-option"
      >
        <input
          type="radio"
          v-model="paymentOption"
          name="payment"
          value="mobilepay"
          id="mobilepay-option"
          class="payment-option"
          @change="doChange($event)"
        />
        <span class="payment_option__control mr-2"></span>
        <i class="icon icon-mobilePay--horizontal"></i>
      </label>
      <label
        class="payment-option-label ml-sm-3 ml-4 mt-4"
        for="betalingsservice-option"
      >
        <input
          type="radio"
          name="payment"
          value="betalingsservice"
          v-model="paymentOption"
          id="betalingsservice-option"
          class="payment-option"
          @change="doChange($event)"
        />
        <span class="payment_option__control mr-2"></span>
        <span>Betalingsservice</span>
      </label>
    </div>
    <div class="d-flex" v-if="isPaymentServiceType || !hasDanishCPR">
      <DoRegNumber
        class="reg"
        v-model="page.Questions[2].Value"
        :value="page.Questions[2].Value"
        :id="page.Questions[2].QID"
        :config="page.Questions[2].Config"
      />
      <DoAccountNumber
        class="account"
        v-model="page.Questions[3].Value"
        :value="page.Questions[3].Value"
        :id="page.Questions[3].QID"
        :config="page.Questions[3].Config"
      />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      page: {
        type: Object,
        required: true,
      },
    },
    methods: {
      doChange(e) {
        this.$store.state.paymentType = e.target.value;
      },
    },
    watch: {},
    computed: {
      ...mapState(['newData']),

      hasDanishCPR: function () {
        return !this.$store.state.hasNoCPR;
      },
      isPaymentServiceType: function () {
        return this.paymentOption === 'betalingsservice';
      },
      paymentOption: {
        get: function () {
          return this.page.Questions[9].Value;
        },
        set: function (newValue) {
          this.page.Questions[9].Value = newValue;
        },
      },
    },
    mounted: function () {
      if (this.$store.state.hasNoCPR) {
        this.paymentOption = 'betalingsservice';
        this.$store.state.paymentType = 'betalingsservice';
      } else {
        this.paymentOption = 'mobilepay';
        this.$store.state.paymentType = 'mobilepay';
      }
    },
  };
</script>

<style lang="scss" scoped>
  .payment_options {
    input {
      opacity: 0;
      width: 0;
      height: 0;

      &:checked + .payment_option__control {
        background: radial-gradient($cyan 100%, rgba(255, 0, 0, 0) 0%);
        border: 0.15em solid #00405f;
      }
    }
    .payment_option__control {
      display: inline-block;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 0.1em solid $blue60;
    }
  }

  span {
    vertical-align: middle;
  }

  .payment-option-label:not(:first-child) {
    margin-right: 25px;
  }

  .reg {
    flex-grow: 0;
    margin-right: 30px;
    width: 70px;
  }

  .account {
    flex-grow: 1;
  }
</style>
